export default __webpack_public_path__ + "static/media/partner4.a723c05c.png";